
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getSetProjectToPlannedDtoFormGroup() {
return new FormGroup({
    priceOffered: new FormControl<number | undefined>(undefined),
})
;
}
      